const sendAnalyticsEvent = (event: string, data?: Record<string, any>) => {
  if (process.env.NEXT_PUBLIC_DEPLOY_ENV !== 'prod') {
    console.info('Dev event:', event, data);
  }

  if (
    process.env.NEXT_PUBLIC_DEPLOY_ENV === 'prod' &&
    window &&
    window.dataLayer
  ) {
    window.dataLayer.push({
      event,
      ...data,
    });
  }
};

export { sendAnalyticsEvent };
